import React from 'react';
import './styles.css';

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    // Every page ends in daylight, including the landing page.
    <footer className="site-footer daylight">
      <div className="footer-card">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <img src="/icons/png/virgil-profile-mark.webp" alt="Virgil" className="footer-logo-img" />
              <span className="footer-logo-text">Virgil</span>
            </div>
            <p className="footer-tagline">
              The operating system for modern storytelling.
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h2>Product</h2>
              <a href="/pricing">Pricing</a>
              <a href="/signup">Start 14-day trial</a>
              <a href="/download">Download</a>
              <a href="/changelog">Changelog</a>
            </div>
            
            <div className="footer-column">
              <h2>Company</h2>
              <a href="/about">About</a>
              <a href="/contact">Contact</a>
            </div>
            
            <div className="footer-column">
              <h2>Legal</h2>
              <a href="/privacy">Privacy Policy</a>
              <a href="/terms">Terms of Service</a>
              <a href="/security">Security</a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>
            © <span suppressHydrationWarning>{currentYear}</span> Virgil AI Inc. All rights reserved.
          </p>
          <p className="footer-colophon">
            Paintings by Eugène Delacroix, Raphael, Rembrandt, and Joseph Wright of Derby, all in the
            public domain. Set in Cormorant Garamond and Manrope.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
